import React from 'react';
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Grid, Paper, Stack, Typography } from '@mui/material';

export function ErrorPage(props: { title?: string; body: string }) {
  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h4" gutterBottom>
            <Stack direction="row" sx={{ alignItems: 'center' }}>
              <ErrorIcon fontSize="inherit" sx={{ marginRight: 1 }} />
              {props.title ?? 'Error'}
            </Stack>
          </Typography>

          <Typography gutterBottom>{props.body}</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
